// removed by extract-text-webpack-plugin
module.exports = {"userEligibilityContainer":"userEligibilityContainer__3NYvh","headingTextContainer":"headingTextContainer__8zYz0","userEligibilityTextContainer":"userEligibilityTextContainer__kP_-U","textContainer":"textContainer__21yow","cardlessEmiText":"cardlessEmiText__P5qF6","subText":"subText__2spAd","logoImage":"logoImage__tv8Rf"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/preApprovedCard/preApprovedContainer/style.css
// module id = 9vbD
// module chunks = 323